module.exports = __webpack_public_path__ + "static/img/icon_water.9519b76e.svg";